import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DhrQuarkusService } from '../../services/dhr.service';
import { AbstractComponent } from '../../abstract-component';

@Component({
  selector: 'app-hazelcast',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './hazelcast.component.html',
  styleUrl: './hazelcast.component.css',
})
export class HazelcastComponent extends AbstractComponent implements OnInit, OnDestroy {
  logs: string = '';
  private sseSubscription: Subscription | undefined;
  
  @ViewChild('logArea') private logArea!: ElementRef;
  private cdr = inject(ChangeDetectorRef);

  constructor() {
    super();
  }

  ngOnInit(): void {
    // Al iniciar nos suscribimos al SSE de Hazelcast
    this.sseSubscription = this.dhrService.getServerSendEventHazelcast().subscribe({
      next: (data) => {
        console.log('Received SSE data:', data);
        
        const itemStr = typeof data === 'string' ? data : JSON.stringify(data);
        this.logs += `[${new Date().toLocaleTimeString()}] ${itemStr}\n`;
        
        // Forzamos la detección de cambios en lugar de usar NgZone
        this.cdr.detectChanges();
        
        // Opcional: auto-scroll hacia abajo
        setTimeout(() => {
          if (this.logArea && this.logArea.nativeElement) {
            this.logArea.nativeElement.scrollTop = this.logArea.nativeElement.scrollHeight;
          }
        }, 0);
      },
      error: (err) => {
        console.error('Error SSE:', err);
        this.logs += `[${new Date().toLocaleTimeString()}] ERROR de conexión SSE\n`;
        this.cdr.detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    // Es crítico desuscribirse para que el Observable invoque el callback de limpieza
    // y haga un 'eventSource.close()', lo que notificará al backend Java
    if (this.sseSubscription) {
      this.sseSubscription.unsubscribe();
    }
  }
}
